import { Stack, Text } from 'braid-design-system';
import React, { type ElementType } from 'react';

import ButtonWrapper from 'src/components/ButtonWrapper/ButtonWrapper';

interface ActionProps {
  Icon: ElementType;
  action: string;
  onClick: () => void;
}

const Action = ({ Icon, action, onClick }: ActionProps) => (
  <ButtonWrapper onClick={onClick}>
    <Stack space="small" align="center">
      <Icon tone="secondary" />
      <Text tone="secondary">{action}</Text>
    </Stack>
  </ButtonWrapper>
);

export default Action;
